<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>第三方平台登录授权</span>
          <el-button v-if="multipleSelection.length == 0" style="float: right;" type="primary" @click="addBtn">创建
          </el-button>
          <div style="float: right;" v-if="multipleSelection.length != 0">
            <span>已选中<i class="checkedNumb"> {{ multipleSelection.length }}</i>
              个</span>
            <el-dropdown trigger="click" @command="operationBtn">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ type: 'del', para: multipleSelection }">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="coreMain">
        <div>
          <el-input class="input-with-select" placeholder="输入平台clientId或平台名称搜索" v-model="search"
            @keyup.enter.native="searchBtn">
          </el-input>
          <el-button @click="searchBtn" icon="el-icon-search" type="primary"></el-button>
          <el-button class="clearSearch" type="text" @click="reset">清除搜索条件</el-button>
        </div>
        <el-table v-loading="loading" ref="multipleTable" :data="tableData" style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="platformName" label="第三方平台名称"></el-table-column>
          <el-table-column prop="clientId" label="平台clientId"></el-table-column>
          <el-table-column prop="webServerRedirectUri" label="重定向地址"></el-table-column>
          <el-table-column prop="authorizedGrantTypes" label="授权类型"></el-table-column>
          <el-table-column label="">
            <template slot-scope="scope">
              <el-dropdown class="briefDetails" style="top:22px;right:32px" @command="command">
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{
                      type: 'edit',
                      data: scope.row,
                    }">编辑</el-dropdown-item>
                  <el-dropdown-item :command="{ type: 'del', id: scope.row.id }">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10,50,100,200,500,1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 创建第三方平台授权条目 -->
    <el-dialog title="新增第三方平台授权条目" :visible.sync="dialogFormVisible">
      <el-form :model="addForm" status-icon ref="addForm" :rules="addFormRules" :label-width="formLabelWidth">
        <el-form-item label="平台名称：" prop="platformName">
          <el-input style="width:70%" v-model="addForm.platformName" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="平台clientId：" prop="clientId">
          <el-input style="width:70%" v-model="addForm.clientId" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="连接密钥（clientSecret）：" prop="clientSecret">
          <el-input style="width:70%" v-model="addForm.clientSecret" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="重定向地址：" prop="webServerRedirectUri">
          <el-input style="width:70%" v-model="addForm.webServerRedirectUri" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="权限类型：" prop="authorizedGrantTypes">
          <el-checkbox-group v-model="addForm.authorizedGrantTypes">
            <el-checkbox label="authorization_code">authorization_code</el-checkbox>
            <el-checkbox label="refresh_token">refresh_token</el-checkbox>
            <el-checkbox label="password">password</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addOnSubmit('addForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改角色 -->
    <el-dialog title="修改第三方平台授权条目" :visible.sync="editdialogFormVisible">
      <el-form :model="editForm" status-icon ref="editForm" :rules="editFormRules" :label-width="formLabelWidth">
        <el-form-item label="平台名称：" prop="platformName">
          <el-input style="width:70%" v-model="editForm.platformName" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="平台clientId：" prop="clientId">
          <el-input style="width:70%" v-model="editForm.clientId" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="重定向地址：" prop="webServerRedirectUri">
          <el-input style="width:70%" v-model="editForm.webServerRedirectUri" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="权限类型：" prop="authorizedGrantTypes">
          <el-checkbox-group v-model="editForm.authorizedGrantTypes">
            <el-checkbox label="authorization_code">authorization_code</el-checkbox>
            <el-checkbox label="refresh_token">refresh_token</el-checkbox>
            <el-checkbox label="password">password</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editdialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editOnSubmit('editForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from "../../api/api";
  import dayjs from "dayjs";
  export default {
    data() {
      return {
        total: 0,
        pageSize: 10,
        currentPage: 1,
        loading: false, //加载条
        search: "", //搜索
        tableData: [],
        multipleSelection: [],
        formLabelWidth: "200px",
        //新增
        addForm: {
          authorizedGrantTypes: [],
          platformName: '',
          clientId: '',
          webServerRedirectUri: '',
          clientSecret: ''
        },
        //编辑
        editForm: {},
        dialogFormVisible: false,
        editdialogFormVisible: false,
        addFormRules: {
          platformName: [{
            required: true,
            message: "请输第三方平台名称",
            trigger: "blur"
          }],
          clientId: [{
            required: true,
            message: "请输入平台clientId",
            trigger: "blur"
          }],
          clientSecret: [{
            required: true,
            message: "请输入连接密钥（clientSecret）",
            trigger: "blur"
          }],
          webServerRedirectUri: [{
            required: true,
            message: "请输入重定向",
            trigger: "blur"
          }]
        },
        editFormRules: {
          platformName: [{
            required: true,
            message: "请输第三方平台名称",
            trigger: "blur"
          }],
          clientId: [{
            required: true,
            message: "请输入平台clientId",
            trigger: "blur"
          }],
          webServerRedirectUri: [{
            required: true,
            message: "请输入重定向",
            trigger: "blur"
          }]
        }
      };
    },
    created() { },
    methods: {
      //获取列表数据
      getPage() {
        let para = {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          search: this.search
        };
        this.loading = true; /*显示加载条*/
        API.oauthClientPage(para)
          .then(res => {
            if (res.code == 1) {
              this.tableData = res.data.resultPage;
              this.total = res.data.total;
            } else {
              this.$message.error(res.msg);
            }
            this.loading = false; /*显示加载条*/
          })

      },
      //搜索功能
      searchBtn() {
        (this.status = ""), //下拉选项为空
          this.getPage();
      },
      //清除搜索条件
      reset() {
        this.search = "";
        this.getPage();
      },

      //批量操作-删除
      operationBtn(val) {
        if (val.type == "del") {
          let arr = [];
          val.para.forEach(element => {
            arr.push(element.id);
          });
          let str = arr.join(",");
          this.delBtn(str);
        }
      },
      //单独删除功能
      command(val) {
        if (val.type == "del") {
          let str = val.id;
          this.delBtn(str);
        }
        if (val.type == "edit") {
          this.editForm = JSON.parse(JSON.stringify(val.data));
          if (this.editForm.authorizedGrantTypes.length > 0) {
            this.editForm.authorizedGrantTypes = this.editForm.authorizedGrantTypes.split(",");
          } else {
            this.editForm.authorizedGrantTypes = []
          }
          console.log(this.editForm);
          this.editdialogFormVisible = true
        }
      },

      //删除功能 单独批量公用
      delBtn(delID) {
        let para = {
          ids: delID
        };
        this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            API.delOauthClient(para).then(res => {
              if (res.code == 1) {
                this.$message.success("删除成功");
                this.getPage();
              } else {
                this.$message.error(res.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      },
      //弹出创建页
      addBtn() {
        this.dialogFormVisible = true;
        if (this.$refs.addForm) {
          this.$refs.addForm.resetFields()
        }
      },

      //创建角色按钮
      addOnSubmit(formName) {
        let _this = this;
        let _API = API;
        this.$refs[formName].validate(valid => {
          if (valid) {
            var json = JSON.parse(JSON.stringify(_this.addForm))
            json.authorizedGrantTypes = json.authorizedGrantTypes.join(",");
            _API.addOauthClient(json).then(res => {
              if (res.code == 1) {
                _this.$message({
                  message: "创建第三方平台授权数据成功",
                  type: "success"
                });
                this.dialogFormVisible = false;
                this.getPage();
              } else {
                _this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      //修改角色
      editOnSubmit(formName) {
        let _this = this;
        let _API = API;
        this.$refs[formName].validate(valid => {
          if (valid) {
            var json = JSON.parse(JSON.stringify(_this.editForm))
            json.authorizedGrantTypes = json.authorizedGrantTypes.join(",");
            _API.editOauthClient(json).then(res => {
              if (res.code == 1) {
                _this.$message({
                  message: "修改第三方平台授权数据成功",
                  type: "success"
                });
                this.editdialogFormVisible = false;
                this.getPage();
              } else {
                _this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      //表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //分页
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getPage();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getPage();
      }
    },
    mounted() {
      this.getPage();
    }
  };

</script>


// WEBPACK FOOTER //
// src/views/platform/thirdPartyAuthorization.vue